<template>
    <div class="footer-style-2">
        <CallToAction
            v-if="data.showFooter"
            :style-type="8"
            title="想要了解更多内容"
            subtitle=""
            btn-text="联系我们"
        />
        <CopyrightTwo v-if="data.showCopyright"/>
        <ScrollTop/>
    </div>
</template>

<script>
    import CopyrightTwo from './CopyrightTwo'
    import CallToAction from '../../elements/callToAction/CallToAction'
    import ScrollTop from './ScrollTop'

    export default {
        name: 'FooterTwo',
        components: {CallToAction, CopyrightTwo, ScrollTop},
        props: {
            data: {
                default: null
            }
        }
    }
</script>